/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import { createGlobalStyle } from "styled-components";
export default createGlobalStyle`

  // body {
  //   font-size:100pt;
  // }

  body {
    font-family: 'Abel', 'Kantumruy Regular', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size:11pt;
  }

  body.fontLoaded {
    font-family: 'Abel', 'Kantumruy Regular', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  .table-responsive td {
    white-space: nowrap;
  }

  /*

  .table-responsive {
    overflow-y: visible !important;
  }

  #dtHorizontalVerticalExample th,
  td {
    white-space: nowrap;
  }


  table.dataTable thead .sorting:after,
  table.dataTable thead .sorting:before,
  table.dataTable thead .sorting_asc:after,
  table.dataTable thead .sorting_asc:before,
  table.dataTable thead .sorting_asc_disabled:after,
  table.dataTable thead .sorting_asc_disabled:before,
  table.dataTable thead .sorting_desc:after,
  table.dataTable thead .sorting_desc:before,
  table.dataTable thead .sorting_desc_disabled:after,
  table.dataTable thead .sorting_desc_disabled:before {
    tbottom: .5em;
  }

  */

  @media print {
    #react-no-print {
      display: none;
    }

    #react-print {
      display: block;
    }

    .print-small td {
      font-size: 12px;
    }

    .no-print {
      display: none;
    }

    .footer {
      page-break-after: always;
    }
  }

  .page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    line-height: 1.25;
    border: 1px solid;
    color: #2ad247;
    background-color: #fff;
    border-color: #d8dbe0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #64da4f;
    border-color: #21c540;
  }

  .tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
    opacity: 1;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

  .order-image img {
    max-width: 300px;
    border-radius: 10px;
  }
  .order-image:hover img {
    width: 500px;
    border-radius: 10px;
  }


 .sidebar-nav {
    position: absolute;
    top: 0;
    width: 250px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .sidebar-nav li {
      text-indent: 20px;
      line-height: 40px;
  }

  .sidebar-nav li a {
      display: block;
      text-decoration: none;
      color: #999999;
  }

  .sidebar-nav li a:hover {
      text-decoration: none;
      color: #fff;
      background: rgba(255,255,255,0.2);
  }

  .sidebar-nav li a:active,
  .sidebar-nav li a:focus {
      text-decoration: none;
  }

  .sidebar-nav > .sidebar-brand {
      height: 65px;
      font-size: 18px;
      line-height: 60px;
  }

  .sidebar-nav > .sidebar-brand a {
      color: #999999;
  }

  .sidebar-nav > .sidebar-brand a:hover {
      color: #fff;
      background: none;
  }

  @media(min-width:768px) {
      #wrapper {
          padding-left: 250px;
      }

      #wrapper.toggled {
          padding-left: 0;
      }

      #sidebar-wrapper {
          width: 250px;
      }

      #wrapper.toggled #sidebar-wrapper {
          width: 0;
      }

      #page-content-wrapper {
          padding: 20px;
          position: relative;
      }

      #wrapper.toggled #page-content-wrapper {
          position: relative;
          margin-right: 0;
      }
  }


  // .c-sidebar .c-sidebar-nav-link.c-active, .c-sidebar .c-active.c-sidebar-nav-dropdown-toggle {
  //   color: #fff;
  //   background: rgba(24, 222, 133, 0.88);
  // }
  //
  // .c-sidebar .c-sidebar-nav-link:hover, .c-sidebar .c-sidebar-nav-dropdown-toggle:hover {
  //     color: #fff;
  //     background: #69F0AE;
  // }

  // .float-right .css-2b097c-container .css-yk16xz-control{
  //   min-width : 250px
  // }

  .tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 200px;
    background-color: #555;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: 50%;
    margin-left: -60px;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

    .arrow-shape-parent {
      display: flex;
      flex-wrap: wrap;
    }

    .arrow-shape {
      idth: 100px;
      height: 40px;
      position: relative;
      background: #78909c;
      margin-right: 10px;
      padding: 12px 10px 0px 15px;
      color: white;
      font-weight: bold;
      font-size: 12px;
    }

    .arrow-shape.active {
      background: #00c852;
    }

    .arrow-shape.active:before {
      border-left: 8px solid #00c852;
    }

    .arrow-shape.read-only.active {
      background: #00c852;
    }

    .arrow-shape.read-only.active:before {
      border-left: 8px solid #00c852;
    }

    .arrow-shape.read-only {
      background: #E0E0E0;
    }

    .arrow-shape.read-only:before {
      border-left: 8px solid #E0E0E0;
    }

    .arrow-shape:hover {
      background: #03bcd4;
    }

    .arrow-shape:hover:before {
      border-left: 8px solid #03bcd4;
    }

    .arrow-shape.read-only:hover {
      background: #E0E0E0;
    }

    .arrow-shape.read-only:hover:before {
      border-left: 8px solid #E0E0E0;
    }


    .arrow-shape:active {
      background: #78909c;
    }

    .arrow-shape.active-red {
      background: #fc0703;
    }
    .arrow-shape.active-red:before {
      border-left: 8px solid #fc0703;
    }

    .arrow-shape:active:before {
      border-left: 8px solid #78909c;
    }

    .arrow-shape:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 0;
      height: 0;
      border-left: 8px solid white;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }

    .arrow-shape:before {
      content: "";
      position: absolute;
      right: -8px;
      bottom: 0;
      width: 0;
      height: 0;
      border-left: 8px solid #78909c;
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
    }

    [data-tooltip] {
      position: relative;
    }

    [data-tooltip]:before,
    [data-tooltip]:after {
      display: none;
      position: absolute;
      top: 0;
    }

    [data-tooltip]:before {
      border-bottom: .6em solid #09f;
      border-bottom: .6em solid rgba(0,153,255,0.8);
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      content: "";
      left: 20px;
      margin-top: 1em;
    }

    [data-tooltip]:after {
      background-color: #0099ff;
      background-color: rgba(0,153,255,0.8);
      border: 4px solid #0099ff;
      border: 4px solid rgba(0,153,255,0.8);
      border-radius: 7px;
      color: #ffffff;
      content: attr(data-tooltip-label) ":\\A" attr(data-tooltip-message);
      left: 0;
      margin-top: 1.5em;
      padding: 5px 15px;
      white-space: pre-wrap;
      width: 100px;
    }

    [data-tooltip]:hover:after,
    [data-tooltip]:hover:before {
      display: block;
    }

    /* DROP DOWN BUTTON TABLE */
    .dropbtn {

    }

    .dropdown {
      position: relative;
      display: inline-block;
    }

    .dropdown-content {
      display: none;
      position: absolute;
      background-color: #f1f1f1;
      min-width: 160px;
      box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
      z-index: 1;
      right: 0px;
    }

    .dropdown-content a {
      color: black;
      padding: 12px 16px;
      text-decoration: none;
      display: block;
    }

    .dropdown-content a:hover {background-color: #ddd;}

    .dropdown:hover .dropdown-content {display: block;}

    .dropdown:hover .dropbtn {background-color: transparent;}

    .table-padding-less th, .table-padding-less td {
      padding : 5px;
    }

    .sliderimg{
      width: 100%;
      height: auto;
      object-fit: cover
    }
    .alice-carousel__prev-btn-wrapper, .alice-carousel__next-btn-wrapper {
      display: none;
    }
    /* .c-sidebar .c-sidebar-brand {
      background-color: #00c852;
    } */

    .span-button {
      cursor: pointer;
      text-decoration-style: dotted;
      text-decoration-line: underline;
    }

    .box-blur {
      backdrop-filter: blur(5px);
    }



    .caption {
      position: absolute;
      top: 10px;
      left: 10px;
      height: 100%;
      width: 50%;
      padding: 0 10px;
      box-sizing: border-box;
      pointer-events: none;
    }

    .archive-button {
      position: absolute;
      top: -10px;
      right: 80px;
      height: 50px;
      width: 50px;
    }

    .save-hub-button {
      position: absolute;
      top: -10px;
      right: 20px;
      height: 50px;
      width: 50px;
    }



    .caption span {
      display: inline-block;
      padding: 10px;
      color: #fff;
      background: rgba(0,0,0,0.8);
      /* font-family: 'Myriad Pro regular'; */
      font-size: 15.31px;
    }
    .grid-card {
      height: 300px;
      overflow: hidden;
      background-color: #ebebeb;
      margin-bottom: 20px;
      z-index: 1;

    }
    /* .image_grid {
      display: inline-block;
      padding-left: 10px;
    }
    .image_grid label {
      position: relative;
      display: inline-block;
    }
    .image_grid img {
      display: block;
    } */
    .image_grid input {
      display: none;
    }

    /* .image_grid input:checked + .caption {
      background: rgba(0,0,0,0.5);
    } */}
    .image_grid input:checked + .caption::after {
      content: '✔';
      position: absolute;
      top: 50%; left: 50%;
      width: 70px; height: 70px;
      transform: translate(-50%,-50%);
      color: green;
      font-size: 60px;
      line-height: 80px;
      text-align: center;
      border: 2px solid green;
      border-radius: 50%;
    }

    .img-thumbnail {
      border:0;
      padding: 0;
      border-radius: 0;
    }


    .ticket-deader {
      background: #f3f3f3;
      border-radius: 10px;
      padding: 10px 10px 10px 10px;
      margin: 0px 0px 30px 0px;
    }

    .urgent-label {
      color: red;
      opacity: 0.7;
      font-size: 10pt;
    }

    .bar-access-height{
      height: 700px;
    }
`;


